module.exports = __webpack_public_path__ + "media/images/clothes3-00d0e438d9712be55e1d9429e20ffa8f.png";